/* eslint-disable react-hooks/exhaustive-deps */
import { Alert } from '@mui/material'
import MatAppBar from '../MatAppBar/MatAppBar'
import { useState, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { makeStyles, createStyles } from '@mui/styles'
import { setShouldRender } from '../ProgressOverlay/store/actionCreator'
import { setExternalWorkOrderList } from '../WorkOrderList/WorkOrderListStore/actionCreator'
import { setAssignments } from '../WorkOrderList/WorkOrderListStore/actionCreator'
import CacheListManager from '../CacheListManager/CacheListManager'
import {
  api,
  INPUT_PERFORMANCE_DELAY,
  SCHEDULE_OR_ASSIGNMENT,
  WORK_ORDER_FILTER_PROPERTIES,
} from '../../globalConstants'
import { fetchData } from '../../service/HttpService'
import { useAuth } from '@praxis/component-auth'
import StatusAlert from '../StatusAlert/StatusAlert'
import CommonCardList from '../CommonCardList/CommonCardList'
import { filterAssignmentsBy7Days } from '../../utils'
import useSearch from '../../utils/hooks/useSearch'

const useStyles = makeStyles((theme) =>
  createStyles({
    warningError: {
      margin: theme.spacing(1),
    },
  }),
)

const ExternalWorkOrders = ({
  externalWorkOrders,
  storeId,
  lastUpdated,
  toggle,
  setAssignments,
  setShouldRender,
  setExternalWorkOrderList,
}) => {
  const classes = useStyles()
  const auth = useAuth()
  const userId = auth.session.userInfo.lanId?.toUpperCase()
  const URL_SEARCH_KEY = 'search'
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const { isDCUser } = useSelector((state) => ({
    ...state.userInfoReducer,
  }))

  const [filteredWorkOrders, onSearch] = useSearch(
    URL_SEARCH_KEY,
    externalWorkOrders || [],
    WORK_ORDER_FILTER_PROPERTIES(isDCUser),
    true,
    INPUT_PERFORMANCE_DELAY,
  )

  const externalWorkOrdersLength = externalWorkOrders.length

  const getAssignments = async () => {
    try {
      setShouldRender(true, 'Loading...', SCHEDULE_OR_ASSIGNMENT(isDCUser))
      const response = await fetchData(api.myAssignments(storeId, userId))
      const assigmentsScheduledThisWeek = filterAssignmentsBy7Days(
        response.assignmentsdata,
      )
      setAssignments(assigmentsScheduledThisWeek)
    } catch (error) {
      setError(true)
    } finally {
      setLoading(false)
      setShouldRender(false)
    }
  }

  useEffect(() => {
    return () => setExternalWorkOrderList([])
  }, [])

  useEffect(() => {
    const getOpenWorkOrders = async () => {
      if (!externalWorkOrdersLength && !loading) {
        try {
          setShouldRender(true, 'Loading...', 'External Work Orders')
          setLoading(true)
          setError(false)
          const response = await fetchData(api.openWorkOrders(storeId))
          setExternalWorkOrderList(response.woDetails)
        } catch (error) {
          setError(true)
        } finally {
          setLoading(false)
          setShouldRender(false)
        }
      }
    }
    getOpenWorkOrders()
  }, [externalWorkOrdersLength])

  useEffect(() => {
    externalWorkOrdersLength && getAssignments()
  }, [toggle, externalWorkOrdersLength])

  const infoMessage = `${filteredWorkOrders.length} / ${externalWorkOrdersLength} External Work Order(s)`

  return (
    <>
      <MatAppBar
        arrowBack
        text="External WOs"
        search={{
          onSearch: (input) => onSearch(input),
          searchKey: URL_SEARCH_KEY,
        }}
      />
      {!loading && externalWorkOrdersLength > 0 && (
        <CacheListManager
          lastUpdated={lastUpdated}
          listLength={externalWorkOrders}
          clearMethod={() => setExternalWorkOrderList([])}
        />
      )}

      {!filteredWorkOrders?.length && !loading && !error && (
        <Alert
          severity="warning"
          data-testid={'no-data-text'}
          className={classes.warningError}
        >
          There are no external work orders to display.
        </Alert>
      )}
      {error && !loading && (
        <Alert severity="error" className={classes.warningError}>
          Unable to connect to work orders service.
        </Alert>
      )}

      {filteredWorkOrders && !loading ? (
        <>
          <StatusAlert text={infoMessage} />
          <CommonCardList
            listData={filteredWorkOrders}
            filteredWorkOrdersLength={externalWorkOrdersLength}
          />
        </>
      ) : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    externalWorkOrders: state.workOrderListReducer.externalWorkOrders,
    storeId: state.storeInfoReducer.storeId,
    lastUpdated: state.workOrderListReducer.lastUpdated.externalWorkOrders,
    toggle: state.workOrderListReducer.toggle,
  }
}

const mapDispatchToProps = {
  setShouldRender,
  setExternalWorkOrderList,
  setAssignments,
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalWorkOrders)
